export default {
  "errors": {
    "notFound": "Ereignis nicht gefunden.",
    "disabled": "Online-Zusagen sind für diese Veranstaltung nicht aktiviert.",
    "loadError": "Seite konnte nicht geladen werden.",
    "searchError": "Wir konnten Ihre Einladung nicht finden. Bitte überprüfen Sie die genaue Schreibweise auf Ihrer Einladung.",
    "genericError": "Ein Fehler ist aufgetreten.",
    "submitError": "Fehler beim Senden Ihrer Antwort."
  },
  "success": {
    "title": "Vielen Dank!",
    "message": "Ihre Antwort wurde erfolgreich gespeichert.",
    "dateMessage": "Wir sehen uns am {{date}}!"
  },
  "header": {
    "title": "Zu- oder Absage",
    "defaultWelcome": "Wir freuen uns darauf, mit Ihnen zu feiern! Bitte bestätigen Sie Ihre Teilnahme."
  },
  "search": {
    "title": "Finden Sie Ihre Einladung",
    "firstName": "Vorname",
    "firstNamePlaceholder": "Jan",
    "lastName": "Nachname",
    "lastNamePlaceholder": "Müller (Optional)",
    "submit": "Suchen",
    "searching": "Suchen..."
  },
  "form": {
    "greeting": "Hallo, {{firstName}} {{lastName}}!",
    "subtitle": "Bitte lassen Sie uns wissen, ob Sie dabei sein werden.",
    "attendance": "Werden Sie teilnehmen?",
    "yes": "Ja, sehr gerne!",
    "no": "Nein, leider nicht",
    "plusOne": {
      "title": "Ihre Begleitung (+1)",
      "label": "Vor- und Nachname der Begleitung",
      "placeholder": "Marie Schmidt"
    },
    "dietary": {
      "title": "Ernährungsbedürfnisse",
      "subtitle": "Bitte kreuzen Sie die Optionen an, die auf Sie (und ggf. Ihre Begleitung) zutreffen.",
      "vegetarian": "Vegetarisch",
      "vegan": "Vegan",
      "glutenFree": "Glutenfrei",
      "porkFree": "Ohne Schweinefleisch",
      "nutAllergy": "Nussallergie",
      "seafoodAllergy": "Meeresfrüchte-Allergie",
      "customPlaceholder": "Weitere Details (spezifische Allergien...)"
    },
    "message": {
      "title": "Eine Nachricht für das Brautpaar?",
      "placeholder": "Hinterlassen Sie eine liebe Nachricht..."
    },
    "submit": "Meine Antwort bestätigen",
    "submitting": "Wird bestätigt..."
  }
};
